"use client";

import { useEffect } from "react";

/**
 * Registers /sw.js in the browser, but only in production builds. The
 * dev server's HMR socket would fight with an active SW (intercepted
 * requests, stale chunks, "you have to hard-reload" loops), so dev
 * skips registration entirely.
 *
 * Renders nothing. Mount once in the root layout.
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    // Fire-and-forget — registration failures are non-fatal (the site
    // works without the SW; we just lose offline fallback + install
    // prompt). Surface via console so a regression is visible to QA.
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        console.warn("[sw] registration failed:", err);
      });
  }, []);
  return null;
}
